import { getChainId, } from "wagmi/actions";
import { wagmiConfig as config, } from "@wagmiconfig";
import { getExplorerLink, } from "@bracket/chainography";

import type { BlockHash, } from "@bracket/types";
import type { ResolverResult, } from "@types";
import type { Notification } from "@bracket/ui";



export const dispatchClaimManagerPerformanceFeesNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return claimManagerPerformanceFeesSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return claimManagerPerformanceFeesFailedNotification(result.error);
}


export const dispatchClaimManagerTvlFeesNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return claimManagerTvlFeesSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return claimManagerTvlFeesFailedNotification(result.error);
}

export const dispatchClaimBrktTvlFeesNotification = (result: ResolverResult): Omit<Notification, "id"> | null => {
	if(result.success) {
		return claimBrktTvlFeesSuccessNotification(result.hash);
	}
	if(result.rejected) {
		return null;
	}
	return claimManagerTvlFeesFailedNotification(result.error);
}

export const claimManagerPerformanceFeesSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Claim successful",
		message: "You successfully claimed the manager performance fees for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}

export const claimBrktTvlFeesSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Claim successful",
		message: "You successfully claimed the Bracket TVL fees for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const claimManagerPerformanceFeesFailedNotification = (error: Error): Omit<Notification, "id"> => {

  const msg = error.message.toLowerCase();
	const message = (
		"please try again"
	);

	console.warn("claim failed", error.message);

	return {
		title: "Claim failure",
		message: `Your claim for the manager performance fees for this vault failed, ${message}`,
		type: "error",
		status: "error",
	}

}


export const claimManagerTvlFeesSuccessNotification = (
	hash: BlockHash,
): Omit<Notification, "id"> => {
	return {
		title: "Claim successful",
		message: "You successfully claimed the manager TVL fees for this vault",
		type: "success",
		status: "success",
		primaryAction: {
			label: "View on explorer",
			onClick: () => {
				window.open(getExplorerLink(hash, getChainId(config)), "_blank");
			},
		},
	}
}


export const claimManagerTvlFeesFailedNotification = (error: Error): Omit<Notification, "id"> => {
  const msg = error.message.toLowerCase();
	const message = (
		"please try again"
	);

  return {
		title: "Claim failure",
		message: `Your claim for the manager TVL fees for this vault failed, ${message}`,
		type: "error",
		status: "error",
	}
} 